"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import SectionHeader from "@/components/ui/section-header";
import { GREEN } from "@/lib/constants";

const STEPS = [
  {
    title: "Die Anwendung sendet eine Anfrage",
    body: "Scraper, Browser oder Automatisierungstool senden die Anfrage an den Proxidize Access Point statt direkt an das Ziel.",
  },
  {
    title: "Proxidize wählt eine Residential-IP",
    body: "Proxidize wählt eine passende Residential-IP entsprechend dem Targeting (Land, Stadt oder ISP) und der Session-Einstellung (rotierend oder sticky).",
  },
  {
    title: "Das Ziel sieht die Residential-IP",
    body: "Die Zielwebsite erhält die Anfrage von dieser Residential-IP, nicht von der IP des eigenen Servers, und die Antwort läuft auf demselben Weg zurück.",
  },
];

export default function ResidentialHowItWorksDe() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="residential-how-it-works-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="So funktioniert es"
            id="residential-how-it-works-heading"
            heading="Wie Residential Proxies funktionieren"
            body="Ein Residential Proxy leitet die Anfrage über eine IP-Adresse, die ein ISP einer echten Wohnanschluss-Verbindung zugewiesen hat. Die Zielwebsite sieht diese Residential-IP statt der IP des eigenen Servers."
          />
          <p className="text-muted-foreground mt-2 mb-8 text-base leading-relaxed">
            Proxidize verbindet Scraper, Browser oder Automatisierungstool mit einem
            Residential-Access-Point. Land, Stadt oder ISP auswählen und festlegen, ob die IP
            zwischen Anfragen rotiert oder für eine längere Session aktiv bleibt.
          </p>
        </div>

        <ol className="grid list-none grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-3">
          {STEPS.map((step, i) => (
            <motion.li
              key={step.title}
              initial={prefersReducedMotion ? false : { opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={scrollRevealViewport}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              className="flex flex-col gap-3"
            >
              <span
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold tabular-nums"
                style={{
                  background: `${GREEN}15`,
                  color: "var(--brand-green)",
                  border: `1px solid ${GREEN}33`,
                }}
              >
                {i + 1}
              </span>
              <div>
                <p className="text-foreground mb-1 text-sm font-semibold">{step.title}</p>
                <p className="text-muted-foreground text-sm leading-relaxed">{step.body}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
